const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "API de Mensajes",
    summary:
      "Integra sistemas externos (CRM, ERP, tiendas en línea o pasarelas de pago) para enviar mensajes de texto y multimedia por WhatsApp mediante llamadas HTTP REST seguras con token de autorización.",
  },
  sections: [
    {
      id: "envio_mensajes",
      title: "1. Endpoints de Envío",
      description:
        "Especificación de URLs, cabeceras de autorización y parámetros JSON para envíos.",
      items: [
        {
          id: "mensajes_texto",
          title: "Envío de Mensajes de Texto",
          definition:
            "Endpoint POST para enviar mensajes individuales indicando número de destino, contenido del mensaje y token de la conexión.",
        },
        {
          id: "mensajes_multimedia",
          title: "Envío de Archivos y Multimedia",
          definition:
            "Permite adjuntar archivos PDF, imágenes, videos o notas de voz especificando la URL pública o archivo multipart.",
        },
      ],
    },
    {
      id: "seguridad_api",
      title: "2. Tokens y Seguridad",
      description:
        "Generación y control de tokens Bearer de autenticación por empresa o conexión.",
      items: [
        {
          id: "bearer_token",
          title: "Token de Autorización",
          definition:
            "Mantén protegido el token en las cabeceras HTTP Authorization para garantizar la seguridad de tus integraciones.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Messages API",
    summary:
      "Integrate external software (CRM, ERP, e-commerce, or payment gateways) to send text and media WhatsApp messages via secure REST HTTP endpoints authenticated with bearer tokens.",
  },
  sections: [
    {
      id: "envio_mensajes",
      title: "1. Dispatch Endpoints",
      description:
        "URLs, headers, and JSON body parameters for automated outbound messages.",
      items: [
        {
          id: "mensajes_texto",
          title: "Text Message API",
          definition:
            "POST endpoint to send single text messages specifying phone number, message body, and authorization token.",
        },
        {
          id: "mensajes_multimedia",
          title: "Media & Attachments API",
          definition:
            "Send PDF documents, images, audio, or videos providing a public URL or multipart payload.",
        },
      ],
    },
    {
      id: "seguridad_api",
      title: "2. Authentication & Tokens",
      description:
        "Generating and managing secure Bearer authentication tokens per connection.",
      items: [
        {
          id: "bearer_token",
          title: "Bearer Token",
          definition:
            "Keep your token safe in HTTP Authorization headers to safeguard your automated dispatches.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "API de Mensagens",
    summary:
      "Integre sistemas externos (CRM, ERP, e-commerce ou gateways de pagamento) para enviar mensagens de texto e mídia via WhatsApp através de requisições HTTP REST autenticadas com token.",
  },
  sections: [
    {
      id: "envio_mensajes",
      title: "1. Endpoints de Envio",
      description:
        "URLs, cabeçalhos de autenticação e parâmetros JSON para disparos automáticos.",
      items: [
        {
          id: "mensajes_texto",
          title: "Envio de Texto",
          definition:
            "Endpoint POST para disparar mensagens informando número de destino, texto e token de autorização.",
        },
        {
          id: "mensajes_multimedia",
          title: "Envio de Mídia e Arquivos",
          definition:
            "Permite anexar PDFs, fotos, vídeos ou áudios fornecendo a URL pública do arquivo.",
        },
      ],
    },
    {
      id: "seguridad_api",
      title: "2. Segurança e Tokens",
      description:
        "Geração e controle de tokens Bearer de acesso por conexão.",
      items: [
        {
          id: "bearer_token",
          title: "Token de Autorização",
          definition:
            "Utilize seu token nos headers HTTP Authorization para garantir a segurança da comunicação.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "API de Messages",
    summary:
      "Connectez des systèmes externes (CRM, ERP, e-commerce) pour envoyer des messages WhatsApp textuels et multimédias via des requêtes REST HTTP sécurisées par jeton Bearer.",
  },
  sections: [
    {
      id: "envio_mensajes",
      title: "1. Points de Terminaison (Endpoints)",
      description:
        "URLs, en-têtes d'autorisation et charges utiles JSON pour l'envoi automatisé.",
      items: [
        {
          id: "mensajes_texto",
          title: "Envoi de Messages Texte",
          definition:
            "Endpoint POST pour envoyer des messages directs avec numéro de destinataire et corps de texte.",
        },
        {
          id: "mensajes_multimedia",
          title: "Envoi de Médias et Fichiers",
          definition:
            "Transmettez des documents PDF, photos, vidéos ou vocaux via URL publique ou payload multipart.",
        },
      ],
    },
    {
      id: "seguridad_api",
      title: "2. Jetons et Sécurité",
      description:
        "Génération et gestion des jetons d'autorisation Bearer.",
      items: [
        {
          id: "bearer_token",
          title: "Jeton d'Autorisation",
          definition:
            "Conservez votre jeton dans l'en-tête Authorization pour protéger vos intégrations.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "واجهة برمجة الرسائل (Messages API)",
    summary:
      "اربط أنظمتك الخارجية (أنظمة إدارة العملاء، المتاجر الإلكترونية، بوابات الدفع) لإرسال رسائل واتساب نصية ووسائط عبر واجهة REST HTTP مؤمنة برمز توثيق.",
  },
  sections: [
    {
      id: "envio_mensajes",
      title: "1. نقاط النهاية للإرسال (Endpoints)",
      description:
        "عناوين الروابط وترويسات التوثيق ومعاملات JSON للإرسال التلقائي.",
      items: [
        {
          id: "mensajes_texto",
          title: "إرسال الرسائل النصية",
          definition:
            "نقطة نهاية POST لإرسال الرسائل الفردية مع تحديد رقم المستلم ومحتوى الرسالة ورمز الاتصال.",
        },
        {
          id: "mensajes_multimedia",
          title: "إرسال الوسائط والملفات",
          definition:
            "إرسال ملفات PDF وصور ومقاطع فيديو وتسجيلات صوتية عبر رابط عام أو ملف مرفق.",
        },
      ],
    },
    {
      id: "seguridad_api",
      title: "2. الأمان ورموز التوثيق",
      description:
        "توليد وإدارة رموز Bearer لتأمين وصول الأنظمة الخارجية.",
      items: [
        {
          id: "bearer_token",
          title: "رمز التفويض (Bearer Token)",
          definition:
            "استخدم رمز التوثيق في ترويسات HTTP Authorization لضمان أمان الإرسال البرمجي.",
        },
      ],
    },
  ],
};

export const MESSAGES_API_HELP_DATA = { es, en, pt, fr, ar };
export default MESSAGES_API_HELP_DATA;
